export default "__VITE_ASSET__rMNO$G4I__"